import { cn } from '@/lib/utils';

const frame = 'h-24 w-[7.5rem] shrink-0';

export function EmptyIllustration({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 96" className={cn(frame, className)} aria-hidden>
      <ellipse cx="60" cy="87" rx="38" ry="5" className="fill-muted" />
      <circle cx="100" cy="18" r="4" className="fill-primary/25" />
      <circle cx="16" cy="34" r="3" className="fill-primary/20" />
      <path
        d="M26 46 36 20h48l10 26v26a6 6 0 0 1-6 6H32a6 6 0 0 1-6-6Z"
        className="fill-card stroke-border"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M26 46h20l5 9h18l5-9h20"
        className="fill-none stroke-border"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect x="44" y="28" width="32" height="5" rx="2.5" className="fill-primary/20" />
      <rect x="48" y="37" width="24" height="4" rx="2" className="fill-muted" />
    </svg>
  );
}

export function LockedIllustration({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 96" className={cn(frame, className)} aria-hidden>
      <ellipse cx="58" cy="88" rx="36" ry="5" className="fill-muted" />
      <rect
        x="18"
        y="12"
        width="74"
        height="60"
        rx="8"
        className="fill-card stroke-border"
        strokeWidth="2"
      />
      <rect x="28" y="24" width="38" height="5" rx="2.5" className="fill-muted" />
      <rect x="28" y="34" width="52" height="5" rx="2.5" className="fill-muted" />
      <rect x="28" y="44" width="26" height="5" rx="2.5" className="fill-muted" />
      <path
        d="M78 55v-7a10 10 0 0 1 20 0v7"
        className="fill-none stroke-primary"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <rect x="71" y="54" width="34" height="27" rx="6" className="fill-primary" />
      <circle cx="88" cy="65" r="3.2" className="fill-primary-foreground" />
      <rect x="86.8" y="66" width="2.4" height="7" rx="1.2" className="fill-primary-foreground" />
    </svg>
  );
}

export function NotFoundIllustration({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 96" className={cn(frame, className)} aria-hidden>
      <ellipse cx="58" cy="88" rx="36" ry="5" className="fill-muted" />
      <rect
        x="24"
        y="8"
        width="58"
        height="72"
        rx="8"
        className="fill-card stroke-border"
        strokeWidth="2"
      />
      <rect x="34" y="20" width="38" height="5" rx="2.5" className="fill-muted" />
      <rect x="34" y="30" width="26" height="5" rx="2.5" className="fill-muted" />
      <rect x="34" y="40" width="32" height="5" rx="2.5" className="fill-muted" />
      <circle cx="78" cy="58" r="15" className="fill-card stroke-primary" strokeWidth="3.5" />
      <circle cx="78" cy="58" r="11" className="fill-primary/10" />
      <path d="m89 69 11 11" className="stroke-primary" strokeWidth="5" strokeLinecap="round" />
      <path
        d="M74 54.5a4.2 4.2 0 1 1 5.6 4c-1 .4-1.6 1.2-1.6 2.3v.7"
        className="fill-none stroke-primary"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <circle cx="78" cy="65.6" r="1.6" className="fill-primary" />
    </svg>
  );
}
